import { render, staticRenderFns } from "./yxtj.vue?vue&type=template&id=5d9a5464&scoped=true"
import script from "./yxtj.vue?vue&type=script&lang=js"
export * from "./yxtj.vue?vue&type=script&lang=js"
import style0 from "./yxtj.vue?vue&type=style&index=0&id=5d9a5464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9a5464",
  null
  
)

export default component.exports